import { APIErrorResponse, ErrorResponse, ParsedErrorResponse } from 'types/fetch';

export default function parseApiError(response: APIErrorResponse): ParsedErrorResponse {
  const genericErrorMsg =
    'Sorry, we are unable to process your request at this time. Please try again later';

  let errorCode;
  let errorMessage = genericErrorMsg;
  let errorObject: ErrorResponse = response;
  let status;

  if (response.error || response.verificationStatus) {
    errorCode = response.verificationStatus || response.error || response.reason || 'VCO_001';
    errorMessage = response.error_description || genericErrorMsg;
    status = response.status || null;

    if (response.error_description && /Error:|Error :/gi.test(response.error_description)) {
      // Pluck error code from response description
      errorCode = response.error_description
        .substring(
          response.error_description.search('Error') + 7,
          response.error_description.indexOf('.')
        )
        .replace(/[: \s]+/g, '');
    }
  } else {
    if (response.ResponseStatus) {
      errorObject = response.ResponseStatus;
    } else if (response.errorResponse) {
      errorObject = response.errorResponse;
    } else if (response.responseStatus) {
      errorObject = response.responseStatus;
    }

    errorCode = errorObject.reason || errorObject.code || 'VCO_001';
    errorMessage = errorObject.message || genericErrorMsg;
    status = errorObject.statusCode || errorObject.status || errorObject.httpStatus || null;
  }

  return {
    errorCode,
    errorMessage,
    errorObject,
    httpStatus: response.httpStatus,
    ok: false,
    status
  };
}
